import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import cssVars from 'css-vars-ponyfill';
import * as __NgCli_bootstrap_1 from "./app/app.module.ngfactory";
import * as __NgCli_bootstrap_2 from "@angular/platform-browser";
if (environment.production) {
    enableProdMode();
}
cssVars({
    include: 'style',
    onlyLegacy: true,
    watch: true
});
__NgCli_bootstrap_2.platformBrowser().bootstrapModuleFactory(__NgCli_bootstrap_1.AppModuleNgFactory)
    .catch(function (err) { return console.log(err); });
